import { IProgram, IProgramsIntoInstitution } from '@ucheba/store/planner/programs/types'

export interface IProgramListProps extends IExtraProps {
  isButtonsIcon?: boolean
  items?: IProgram[]
  institutions?: IProgramsIntoInstitution[]
  showAlso?: (id: number, excludeIds: number[]) => void
  showLinkToOtherPrograms?: boolean
  handleDeleteUZ?: (ids: number[], programIds: number[]) => void
  showMoreButton?: boolean
}

export interface IProgramListItemProps extends IProgram, IExtraProps {}

interface IExtraProps {
  selectedIds?: number[]

  showButtons?: boolean

  /* коллбэк сробатывающий при клике на кнопку выбрать */
  onSelect?: (id: number, institutionId?: number) => void

  /* коллбэк срабатывающий при клике на копку выбрано */
  offSelect?: (id: number, institutionId?: number) => void

  /* массив предметов егэ */
  exams?: {
    id: number
    name: string
  }[]

  /* группировать по вузам */
  groupByVuz?: boolean

  toggleBtnToRemove?: boolean

  /* показывать логотип вуза? */
  showLogo?: boolean

  /* выделить предметы которых нет в профиле */
  showExamsInProfile?: boolean
}

export enum ETextColorCheap {
  yellow = 'orange',
  lime = 'emerald',
  rose = 'red',
}
